import { Styling } from '../types';

/**
 * Dynamically applies custom styling by updating CSS variables in the :root element.
 *
 * @param styling - The custom styling configuration.
 */
export function applyCustomStyling(styling: Styling): void {
	const root = document.documentElement;

	// Map UK spelling to US spelling
	const stylingMap: Record<string, string> = {
		backgroundColour: 'backgroundColor',
		backgroundColourLight: 'backgroundColorLight',
		backgroundColourMedium: 'backgroundColorMedium',
		backgroundColourDark: 'backgroundColorDark',
		warningBackgroundColour: 'warningBackgroundColor',
		warningTextColour: 'warningTextColor',
		errorBackgroundColour: 'errorBackgroundColor',
		alertBackgroundColour: 'alertBackgroundColor',
		errorTextColour: 'errorTextColor',
	};

	// Normalize UK spellings to US spellings
	Object.entries(stylingMap).forEach(([ukKey, usKey]: [string, string]) => {
		if (styling[ukKey as keyof Styling]) {
			styling[usKey as keyof Styling] = styling[ukKey as keyof Styling];
		}
	});

	// Apply styles using US spelling
	if (styling.backgroundColor) {
		root.style.setProperty('--aex-custom-background-color', styling.backgroundColor);
	}
	if (styling.backgroundColorLight) {
		root.style.setProperty('--aex-custom-background-color--light', styling.backgroundColorLight);
	}
	if (styling.backgroundColorMedium) {
		root.style.setProperty('--aex-custom-background-color--medium', styling.backgroundColorMedium);
	}
	if (styling.backgroundColorDark) {
		root.style.setProperty('--aex-custom-background-color--dark', styling.backgroundColorDark);
	}
	if (styling.warningBackgroundColor) {
		root.style.setProperty('--aex-custom-warning-background-color', styling.warningBackgroundColor);
	}
	if (styling.warningTextColor) {
		root.style.setProperty('--aex-custom-warning-text-color', styling.warningTextColor);
	}
	if (styling.errorBackgroundColor) {
		root.style.setProperty('--aex-custom-error-background-color', styling.errorBackgroundColor);
	}
	if (styling.alertBackgroundColor) {
		root.style.setProperty('--aex-custom-alert-background-color', styling.alertBackgroundColor);
	}
	if (styling.errorTextColor) {
		root.style.setProperty('--aex-custom-error-text-color', styling.errorTextColor);
	}
}
